import { render, staticRenderFns } from "./FormTires.vue?vue&type=template&id=56c17ea1&scoped=true&"
import script from "./FormTires.vue?vue&type=script&lang=js&"
export * from "./FormTires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c17ea1",
  null
  
)

export default component.exports